export const MODAL_CONFIG = {
  destroyOnClose: true,
  width: 450,
  centered: false,
  maskClosable: false,
  footer: null,
  title: "",
  transitionName: "",
  // maskTransitionName: "",
  // className: "animate__animated animate__fadeInUp",
};
